import React, { useRef, useState, useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {
	dashboardImg,
	adsImg,
	action,
	product,
	geo,
	timeImg,

} from "../../../../../images/index.js";
import { motion, AnimatePresence } from "motion/react";
import { Link } from "react-router-dom";
gsap.registerPlugin(ScrollTrigger);

const features = [
  {
    title: "Smart Dashboard",
    description:
      "One-page view of your entire business.",
    image: dashboardImg,

  },
  {
    title: "Ad Insights",
    description:
      "Real-time Ad Insights to measure reach, engagement & ROI in seconds.",
    image: adsImg,

  },
  {
    title: "Geo Sales Insights",
    description:
      "See where your business wins and where it leaks.",
    image: geo,

  },
  {
    title: "Time-based Performance",
    description:
      "Discover which hour, day, or week drives sales.",
    image: timeImg,

  },
  {
    title: "Product Growth Tracker",
    description:
      "Toggle week or month to uncover growth streaks.",
    image: product,
  },
  {
    title: "Action Recommendations",
    description:
      "Your real-time business health tracker.",
    image: action,

  },
];

export default function StepSectionDesign() {
const [activeStep, setActiveStep] = useState(0);
const [dotTop, setDotTop] = useState("-10px");


  const stepRefs = useRef([]);
  const tabsRefs = useRef([]);
  const total = features.length - 1;
  const progressDotRef = useRef(null);
  const featureRefs = useRef([]);
  const containerRef = useRef(null);


  const activeIndex = activeStep;   // FIXED

  // 🟣 Smoothly calculate the dot's vertical position
  useEffect(() => {
    if (!containerRef.current || !featureRefs.current[activeIndex]) return;

    const activeEl = featureRefs.current[activeIndex];
    const containerTop =
      containerRef.current.getBoundingClientRect().top + window.scrollY;

    const elementTop = activeEl.getBoundingClientRect().top + window.scrollY;
    const offset = activeIndex === 0 ? 10 : 30;

    const newTop = `${elementTop - containerTop + 20 + offset}px`;

    setDotTop(newTop);
  }, [activeIndex]);

  


  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const stepIndex = Number(entry.target.dataset.step);
            setActiveStep(stepIndex);
          }
        });
      },
      { root: null, threshold: 0.5 }
    );

    stepRefs.current.forEach((step) => step && observer.observe(step));

    return () => {
      stepRefs.current.forEach((step) => step && observer.unobserve(step));
    };
  }, []);

  useEffect(() => {
    // update tabs
    tabsRefs.current.forEach((tab, idx) => {
      if (!tab) return;
      tab.classList.toggle("is-active", idx === activeStep);
    });

    // update progress dot
    if (progressDotRef.current) {
      const offset = (activeStep / total) * 100;
      progressDotRef.current.style.transform = `translate(-50%, ${offset}%)`;
    }
  }, [activeStep, total]);

  const handleTabClick = (index) => {
    const targetStep = stepRefs.current[index];
    if (targetStep) {
      targetStep.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };
    const floatingItems = [
    {
      text: "User Friendly Visualization",
      className: "floating-tag top-left",
    },
    {
      text: "Actionable Alerts",
      className: "floating-tag top-right",
    },
    {
      text: "Comprehensive Coverage",
      className: "floating-tag bottom-left",
    },
    {
      text: "Real-Time Insights",
      className: "floating-tag bottom-right",
    },
  ];

  return (
 <section className="feature-story mb-5" id="we-deliver">
      <div className="feature-story__inner ">
        {/* Sticky left side */}
          <div className="feature-story__heading">
            <motion.h2
            className="hero-heading mb-3 text-center"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut",delay:0.1 }}
            viewport={{ once: false }}
            >
            From “Maybe” to “Actionable”        </motion.h2>
            <motion.p className="hero-sub-text mt-4 text-center"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut",delay:0.2}}
            viewport={{ once: false }}
            >
            Actionable insights that helps you to empower your Amazon strategy, decisions, and time for every department        </motion.p>
          </div>
          <div className="feature-story__sticky">

            <div className="feature-story__body" ref={containerRef}>
              {/* Progress bar */}
              <div className="feature-story__progress">
                <div
                className="position-absolute"
                style={{
                  left: "0",
                  top: "-28px",
                  bottom: "-25px",
                  width: "25px",
                  background: "linear-gradient(180deg, #8b5cf6 0%, #a78bfa 100%)",
                  borderRadius: "24px",
                }}
              />
              {/* 🟣 Purple Dot (slow & smooth both ways) */}
              <div
                className="position-absolute"
                style={{
                  left: "0",
                  top: dotTop,
                  width: "25px",
                  height: "25px",
                  background:
                    "linear-gradient(342.08deg, #ECC2D8 -91.14%, #362BDF 104.1%)",
                  borderRadius: "24px",
                  zIndex: 10,
                  transition: "top 1.8s cubic-bezier(0.65, 0, 0.35, 1)",
                }}
              />
              </div>

              {/* Left tabs/list */}
              <ul className="feature-story__tabs">
                  {features.map((feature, idx) => {
                  const isActive = activeIndex === idx;
                  return (
                          <li
                        key={idx}
                        ref={(el) => (featureRefs.current[idx] = el)}  // 👈 dot tracks this
                        className="feature-tab-wrapper"
                      >
                    <div
                    key={idx}
                    ref={(el) => (tabsRefs.current[idx] = el)}
                    className={`feature-tab ${idx === activeIndex ? "is-active" : ""}`}
                      style={{
                        background: isActive
                          ? "linear-gradient(342.08deg, #ECC2D8 -91.14%, #362BDF 104.1%)"
                          : "transparent",
                        borderRadius: "24px",
                        padding: isActive ? "44px 26px" : "5px",
                        marginLeft: "25px",
                        transition: "all 1.2s cubic-bezier(0.65, 0, 0.35, 1)",
                        width:"80%"

                      }}
                    >
                      <h4
                        className="what-section-left-text mb-2"
                        style={{
                          opacity: isActive ? 1 : 0.5,
                          transition: "opacity 0.8s ease-in-out",
                        }}
                      >
                        {feature.title}
                      </h4>
                      {isActive && (
                        <p className="mb-0 what-section-left-sub-text">
                          {feature.description}
                        </p>
                      )}
                    </div>
                    </li>
                  );
                })}
              </ul>

              {/* Right images */}
              <div className="feature-story__visual">

                <AnimatePresence mode="wait">
                  <motion.img
                    key={features[activeIndex].image}
                    src={features[activeIndex].image}
                    alt={features[activeIndex].title}
                    // className="frame-content"
                    className={`frame-content ${activeStep === features[activeIndex] ? "is-active" : ""}`}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}                  />
                </AnimatePresence>

              </div>
            </div>
          </div>

        {/* Invisible scroll "steps" that drive the animation */}
        <div className="feature-story__scroll-steps ">
          {features.map((_, idx) => (
            <div
              key={idx}
              ref={(el) => (stepRefs.current[idx] = el)}
              className="scroll-step"
              data-step={idx}
            ></div>
          ))}
        </div>
      </div>
    </section>
  );
}
